import { Column } from "primereact/column";
import CmsService from "../../../service/CmsService";
import GenericGrid from "../../common/GenericGrid";
import { useEffect, useInsertionEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataGrid from "../../common/DataGrid";
import { useTranslation } from "react-i18next";

export function TempGrid(){
    const {t}=useTranslation();
    let nav = useNavigate();
    const commandMenuItems=[];

    const [reload,setReload]=useState(false);
    const [selectedTemps,setSelectedTemps]=useState([]);
    const [temps,setTemps]=useState([]);

    const loadRecords=()=>{
        CmsService.getTemps().then((recs)=>{
            setTemps(recs);
            setReload(false);
        })
    }
    const onEdit=(rec)=>{
        nav('/itembank/temp/'+rec.id);
    }
    const onInsert=()=>{
        nav('/itembank/temp');
    }
    const onDeleteRecords=(ids)=>{
        return CmsService.deleteTemp(ids[0]);
    }
    useEffect(()=>{
        loadRecords();
    },[]);
    const commandAction=(cmd)=>{}
    return(
        <>
            <DataGrid reload={reload} recs={temps} loadRecords={loadRecords} selectedRecs={selectedTemps} setRecs={setTemps} setSelectedRecs={setSelectedTemps}
                    insertRecord={onInsert} editRecord={onEdit} deleteRecords={onDeleteRecords} t={t}               
                    parentId={0} insertMenu deleteMenu editButton> 
                <Column header={t("Id")} field="id" style={{width:'20%'}} sortable/>
                <Column header={t("Name")} field="name" style={{width:'50%'}} sortable/>
                <Column header={t("Creation_Date")} field='timeCreated' style={{minWidth:'150px'}} sortable/>
            </DataGrid>
        </>
    )
}